import { ConciliacionesReglaConciliacionFormPage } from "@finanedi.es/front-ops"
import { useReglasConciliacionForm } from "./hooks"

export const ReglasConciliacionForm = () => {
  const { handleSuccess, reglaId, tipoValue, ibanValue, cuentaIdValue } =
    useReglasConciliacionForm()

  return (
    <ConciliacionesReglaConciliacionFormPage
      reglaId={reglaId || "nueva"}
      tipo={tipoValue}
      cuenta={{
        id: cuentaIdValue ?? "",
        iban: ibanValue ?? "",
      }}
      onSuccess={handleSuccess}
    />
  )
}
